/* Blueprint garment shapes — drawn by hand, not traced.
 *
 * An earlier version auto-traced the product flats. The silhouettes were
 * technically the real garments but they read as lumpy and accidental, so
 * these are drawn instead: four clean shapes, one per garment type.
 *
 * Coordinate space: x 0..1 is the BODY width — the measured chest or waist,
 * flat — so sleeves deliberately run negative and past 1. y 0..1 is the
 * measured length, shoulder to hem. The guide scales x by width and y by
 * length independently, which keeps the dimension lines honest: they mark the
 * body, not the sleeve span.
 *
 * `body` is the filled outline. `detail` is stroke-only — collar, placket,
 * waistband — and never affects the measured box.
 */
window.MammisiShapes = {

  tee: {
    body:
      "M0 0.055" +
      "C-0.06 0.02 -0.17 0.03 -0.255 0.075" +
      "C-0.265 0.15 -0.25 0.23 -0.23 0.29" +
      "C-0.15 0.315 -0.07 0.32 0 0.30" +
      "C0 0.53 0 0.77 0.008 1" +
      "L0.992 1" +
      "C1 0.77 1 0.53 1 0.30" +
      "C1.07 0.32 1.15 0.315 1.23 0.29" +
      "C1.25 0.23 1.265 0.15 1.255 0.075" +
      "C1.17 0.03 1.06 0.02 1 0.055" +
      "C0.86 0.11 0.68 0.14 0.5 0.14" +
      "C0.32 0.14 0.14 0.11 0 0.055Z",
    detail:
      "M0.055 0.075C0.19 0.128 0.34 0.155 0.5 0.155C0.66 0.155 0.81 0.128 0.945 0.075"
  },

  polo: {
    body:
      "M0 0.055" +
      "C-0.06 0.02 -0.17 0.03 -0.255 0.075" +
      "C-0.265 0.15 -0.25 0.23 -0.23 0.29" +
      "C-0.15 0.315 -0.07 0.32 0 0.30" +
      "C0 0.53 0 0.77 0.008 1" +
      "L0.992 1" +
      "C1 0.77 1 0.53 1 0.30" +
      "C1.07 0.32 1.15 0.315 1.23 0.29" +
      "C1.25 0.23 1.265 0.15 1.255 0.075" +
      "C1.17 0.03 1.06 0.02 1 0.055" +
      "C0.87 0.10 0.70 0.125 0.5 0.125" +
      "C0.30 0.125 0.13 0.10 0 0.055Z",
    detail:
      "M0.30 0.062L0.445 0.20L0.5 0.128L0.555 0.20L0.70 0.062" +
      "M0.455 0.20L0.455 0.35M0.545 0.20L0.545 0.35"
  },

  shirt: {
    body:
      "M0 0.05" +
      "C-0.06 0.015 -0.175 0.025 -0.262 0.07" +
      "C-0.272 0.148 -0.257 0.232 -0.236 0.295" +
      "C-0.155 0.32 -0.072 0.325 0 0.305" +
      "C0 0.535 0 0.775 0.006 0.985" +
      "C0.28 1.005 0.72 1.005 0.994 0.985" +
      "C1 0.775 1 0.535 1 0.305" +
      "C1.072 0.325 1.155 0.32 1.236 0.295" +
      "C1.257 0.232 1.272 0.148 1.262 0.07" +
      "C1.175 0.025 1.06 0.015 1 0.05" +
      "C0.88 0.09 0.71 0.115 0.5 0.115" +
      "C0.29 0.115 0.12 0.09 0 0.05Z",
    detail:
      "M0.275 0.055L0.45 0.215L0.5 0.118L0.55 0.215L0.725 0.055" +
      "M0.5 0.118L0.5 0.985" +
      "M0.425 0.30L0.425 0.985"
  },

  trouser: {
    body:
      "M0 0" +
      "L1 0" +
      "C1.02 0.28 1.03 0.64 1.018 0.995" +
      "L0.60 0.995" +
      "C0.575 0.80 0.545 0.66 0.5 0.55" +
      "C0.455 0.66 0.425 0.80 0.40 0.995" +
      "L-0.018 0.995" +
      "C-0.03 0.64 -0.02 0.28 0 0Z",
    detail:
      "M0.005 0.085L0.995 0.085" +
      "M0.5 0.085L0.5 0.55"
  }
};

/* Which shape each garment takes. Anything not listed falls back to the
   chart's own `kind` — trousers for a bottom, tee for a top. */
window.MammisiGarments = {
  "coastal blue": "shirt",
  "pink pepper":  "tee",
  "Truffle Tee":  "tee",
  "honey dune":   "polo",
  "Truffle Polo": "polo",
  "sandstone":    "trouser",
  "salty white":  "trouser"
};
